import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../Components/Functions/date.fun";
import CustomViewButton from "../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Execution Id",
  // "Agent Id",
  "User Number",
  "Agent Number",
  "Summary",
  "Duration",
  "Call Status",
  "Enq Whatsapp Sent",
  "Info Whatsapp Sent",
  "Actions",
];

// const getTableHead = (role) => {
//   const base = [
//     "Sr.",
//     "Name / Phone No",
//     "Department / Date",
//     "Joinig Date",
//     "Salary Expectation",
//   ];

//   if (role !== "client") {
//     base.push("Remarks");
//   }

//   base.push("Actions");

//   return base;
// };

const GetAiVoiceTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/get-ai-call-log/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.execution_id || "N/A"}</td>
                {/* <td>{item?.agent_id || "N/A"}</td> */}
                <td>{item?.user_number || "N/A"}</td>
                <td>{item?.agent_number || "N/A"}</td>
                <td>{item?.summary || "N/A"}</td>
                <td>{item?.duration || "N/A"}</td>
                <td>{item?.status || "N/A"}</td>
                <td>
                  {item?.whatsappSent ? (
                    <span className="badge bg-green-lt">Sent</span>
                  ) : (
                    <span className="badge bg-red-lt">Not Sent</span>
                  )}
                </td>

                <td>
                  {item?.whatsappInfoSent ? (
                    <span className="badge bg-green-lt">Sent</span>
                  ) : (
                    <span className="badge bg-red-lt">Not Sent</span>
                  )}
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GetAiVoiceTable;
